import { useContext } from 'react';
import { ScaffolderPageContext } from './ScaffolderPageContext';

export const useScaffolderPageContext = () => useContext(ScaffolderPageContext);
